import { Track } from "@/src/lib/tracking";
import React, { FC } from "react";
import { cn } from "utils";
import { SubscriptionActionProps } from "./types";
import Translations from "@translate/components/Member/CurrentPlan/ManageBillingModal/SubscriptionAction";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

/**
 * 订阅操作组件，包含取消订阅按钮
 */
const SubscriptionAction: FC<SubscriptionActionProps> = ({
  onCancelSubscription,
  className,
  buttonClassName,
}) => {
  const handleCancelClick = () => {
    // 记录日志
    Track.log("info", "member", "-[cancelSubscription]");
    // 调用取消订阅回调
    onCancelSubscription();
  };

  return (
    <div
      className={cn(
        "self-stretch flex justify-end items-start mt-6",
        className,
      )}
    >
      <button
        aria-label="Subscription Action"
        data-openreplay-label="member_subscriptionaction_close"
        id="btn-subscription-action"
        onClick={handleCancelClick}
        className={cn(
          "px-2 py-[6px] rounded-md border border-border_white_transparent20 flex justify-center items-center gap-2 md:hover:bg-background_white_overlay5 transition-colors",
          buttonClassName,
        )}
      >
        <div className="text-content_primary button_s">
          {I18n.t("Manage Subscription")}
        </div>
      </button>
    </div>
  );
};

export default SubscriptionAction;
